
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $698974e9dd92c2ec$exports = {};

$parcel$export($698974e9dd92c2ec$exports, "focus-ring", () => $698974e9dd92c2ec$export$f39a09f249340e2a, (v) => $698974e9dd92c2ec$export$f39a09f249340e2a = v);
$parcel$export($698974e9dd92c2ec$exports, "i18nFontFamily", () => $698974e9dd92c2ec$export$8c4ee2c50c22c514, (v) => $698974e9dd92c2ec$export$8c4ee2c50c22c514 = v);
$parcel$export($698974e9dd92c2ec$exports, "spectrum", () => $698974e9dd92c2ec$export$3311ab3a441bc141, (v) => $698974e9dd92c2ec$export$3311ab3a441bc141 = v);
$parcel$export($698974e9dd92c2ec$exports, "spectrum-FocusRing-ring", () => $698974e9dd92c2ec$export$4109102f950813a6, (v) => $698974e9dd92c2ec$export$4109102f950813a6 = v);
$parcel$export($698974e9dd92c2ec$exports, "spectrum-FocusRing", () => $698974e9dd92c2ec$export$24c7f46a6e3605dd, (v) => $698974e9dd92c2ec$export$24c7f46a6e3605dd = v);
$parcel$export($698974e9dd92c2ec$exports, "spectrum-FocusRing--quiet", () => $698974e9dd92c2ec$export$2927016961429360, (v) => $698974e9dd92c2ec$export$2927016961429360 = v);
var $698974e9dd92c2ec$export$f39a09f249340e2a;
var $698974e9dd92c2ec$export$8c4ee2c50c22c514;
var $698974e9dd92c2ec$export$3311ab3a441bc141;
var $698974e9dd92c2ec$export$4109102f950813a6;
var $698974e9dd92c2ec$export$24c7f46a6e3605dd;
var $698974e9dd92c2ec$export$2927016961429360;
$698974e9dd92c2ec$export$f39a09f249340e2a = `_t8qIa_focus-ring`;
$698974e9dd92c2ec$export$8c4ee2c50c22c514 = `_t8qIa_i18nFontFamily`;
$698974e9dd92c2ec$export$3311ab3a441bc141 = `_t8qIa_spectrum`;
$698974e9dd92c2ec$export$4109102f950813a6 = `_t8qIa_spectrum-FocusRing-ring`;
$698974e9dd92c2ec$export$24c7f46a6e3605dd = `_t8qIa_spectrum-FocusRing ${$698974e9dd92c2ec$export$4109102f950813a6}`;
$698974e9dd92c2ec$export$2927016961429360 = `_t8qIa_spectrum-FocusRing--quiet`;


export {$698974e9dd92c2ec$exports as default};
//# sourceMappingURL=page_vars_css.module.js.map
